/* ══════════════════════════════════════════
   ASWEARE Theme — JavaScript
══════════════════════════════════════════ */
(function() {
'use strict';
var R = document.documentElement;

// Default gradient (blue sky) — can be overridden by the homepage section meta tag.
// This can change in Shopify's theme editor when sections/settings are re-rendered,
// so keep it in a function instead of reading it only once.
var DG = { g1: '#062536', g2: '#83d4f4', g3: '#d8f6ff', tc: '#ffffff' };
function updateDefaultGradient() {
  var meta = document.querySelector('meta[name="aw-default-gradient"]');
  if (!meta) return DG;
  try {
    var d = JSON.parse(meta.content || '{}');
    if (d.g1 && d.g2 && d.g3) {
      DG = {
        g1: d.g1,
        g2: d.g2,
        g3: d.g3,
        tc: d.tc || '#ffffff'
      };
    }
  } catch(e) {}
  return DG;
}
updateDefaultGradient();

var currentGradient = '';
var awGradientTimer = null;

function makeGradient(g1, g2, g3) {
  // ASWEARE atmosphere: treat colors like lighting, not equal color stops.
  // g1 = main atmosphere, g2 = highlight/bloom, g3 = shadow/vignette.
  return 'radial-gradient(ellipse 95% 120% at 0% 50%, ' + g3 + ' 0%, transparent 62%),' +
    'radial-gradient(ellipse 90% 100% at 62% 38%, ' + g1 + ' 0%, transparent 72%),' +
    'radial-gradient(ellipse 75% 95% at 92% 52%, ' + g2 + ' 0%, transparent 70%),' +
    'radial-gradient(ellipse 130% 100% at 50% 115%, rgba(3,15,24,.92) 0%, transparent 54%),' +
    'linear-gradient(90deg, ' + g3 + ' 0%, ' + g1 + ' 50%, ' + g2 + ' 100%)';
}

function setGradient(g1, g2, g3, tc, fast) {
  if (!g1 || !g2 || !g3) return;

  var base = document.getElementById('aw-bg');
  var next = document.getElementById('aw-bg-next');
  var newGradient = makeGradient(g1, g2, g3);
  // Slower, more cinematic fades. Collection/page changes should never snap.
  var duration = fast === false ? 1400 : 1100;

  // Text can update immediately, but do NOT update --g1/--g2/--g3 before
  // the crossfade. Those CSS variables are used by the CSS background fallback,
  // and changing them early can make the base layer repaint instantly/flash.
  R.style.setProperty('--tc', tc || '#ffffff');

  if (!base) {
    R.style.setProperty('--g1', g1);
    R.style.setProperty('--g2', g2);
    R.style.setProperty('--g3', g3);
    return;
  }

  // First paint: set the base layer directly so later hovers have something to
  // crossfade FROM. This prevents first-hover snaps on collection/product pages.
  if (!currentGradient || !base.style.background) {
    base.style.background = newGradient;
    currentGradient = newGradient;
    R.style.setProperty('--g1', g1);
    R.style.setProperty('--g2', g2);
    R.style.setProperty('--g3', g3);
    if (next) {
      next.style.transition = 'none';
      next.style.opacity = '0';
      next.style.background = newGradient;
      next.offsetHeight;
      next.style.transition = 'opacity ' + duration + 'ms cubic-bezier(.25,.46,.45,.94)';
    }
    return;
  }

  if (newGradient === currentGradient) {
    R.style.setProperty('--g1', g1);
    R.style.setProperty('--g2', g2);
    R.style.setProperty('--g3', g3);
    return;
  }

  if (!next) {
    base.style.background = newGradient;
    currentGradient = newGradient;
    R.style.setProperty('--g1', g1);
    R.style.setProperty('--g2', g2);
    R.style.setProperty('--g3', g3);
    return;
  }

  window.clearTimeout(awGradientTimer);

  // Reset the next layer invisibly, set its new gradient, then fade it in.
  next.style.transition = 'none';
  next.style.opacity = '0';
  next.style.background = newGradient;
  next.offsetHeight;
  next.style.transition = 'opacity ' + duration + 'ms cubic-bezier(.25,.46,.45,.94)';

  requestAnimationFrame(function() {
    next.style.opacity = '1';
  });

  awGradientTimer = window.setTimeout(function() {
    base.style.background = newGradient;
    currentGradient = newGradient;

    // Now that the visual fade is complete, sync the CSS variables for text,
    // controls, and any fallback styles.
    R.style.setProperty('--g1', g1);
    R.style.setProperty('--g2', g2);
    R.style.setProperty('--g3', g3);
    R.style.setProperty('--tc', tc || '#ffffff');

    next.style.transition = 'none';
    next.style.opacity = '0';
    next.offsetHeight;
    next.style.transition = 'opacity ' + duration + 'ms cubic-bezier(.25,.46,.45,.94)';
  }, duration + 80);
}

window.awSetGradient = setGradient;

function applyDefaultGradient(fast) {
  updateDefaultGradient();
  setGradient(DG.g1, DG.g2, DG.g3, DG.tc, fast !== false);
}

function colorWorldFromText(text) {
  var k = (text || '').toLowerCase();
  if (k.indexOf('rose') > -1 || k.indexOf('pink') > -1) {
    return { g1: '#d4897a', g2: '#b05060', g3: '#702030', tc: '#1a0a0d' };
  }
  if (k.indexOf('green') > -1 || k.indexOf('forest') > -1) {
    return { g1: '#185a38', g2: '#287848', g3: '#061810', tc: '#c8f0d8' };
  }
  if (k.indexOf('grey') > -1 || k.indexOf('gray') > -1 || k.indexOf('cement') > -1) {
    return { g1: '#606058', g2: '#807870', g3: '#282420', tc: '#e0dcd8' };
  }
  if (k.indexOf('blue') > -1 || k.indexOf('royal') > -1) {
    return { g1: '#2060c0', g2: '#5090cc', g3: '#0a2050', tc: '#ddeeff' };
  }
  return null;
}

function applyColorWorldFromText(text, fast) {
  var w = colorWorldFromText(text);
  if (!w) return false;
  setGradient(w.g1, w.g2, w.g3, w.tc, fast !== false);
  return true;
}

/* ═══ PARALLAX ═══ */
var mx = 0, my = 0, tx = 0, ty = 0, raf = null;
function tick() {
  tx += (mx - tx) * 0.04;
  ty += (my - ty) * 0.04;
  var els = document.querySelectorAll('.aw-floating-product');
  for (var i = 0; i < els.length; i++) {
    var dep = parseFloat(els[i].dataset.depth) || 1;
    els[i].style.transform = 'translate(' + (tx * dep * 4) + 'px,' + (ty * dep * 3) + 'px)';
  }
  raf = requestAnimationFrame(tick);
}
function startP() { if (!raf) tick(); }
function stopP() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
document.addEventListener('mousemove', function(e) {
  mx = (e.clientX / window.innerWidth - 0.5) * 2;
  my = (e.clientY / window.innerHeight - 0.5) * 2;
});

/* ═══ FLOATING PRODUCTS — hover/touch gradient ═══ */
function applyFloatingGradient(el, fast) {
  if (!el) return;
  var a = el.getAttribute('data-gradient-1'),
      b = el.getAttribute('data-gradient-2'),
      c = el.getAttribute('data-gradient-3'),
      t = el.getAttribute('data-text-color') || '#ffffff';
  if (a && b && c) setGradient(a, b, c, t, fast !== false);
}
function resetDefaultGradient() {
  applyDefaultGradient(true);
}

function gradientDataFromElement(el) {
  if (!el) return null;
  var a = el.getAttribute('data-gradient-1'),
      b = el.getAttribute('data-gradient-2'),
      c = el.getAttribute('data-gradient-3'),
      t = el.getAttribute('data-text-color') || '#ffffff';
  if (!a || !b || !c) return null;
  return { g1: a, g2: b, g3: c, tc: t };
}

function applyElementGradient(el, fast) {
  var d = gradientDataFromElement(el);
  if (!d) return false;
  setGradient(d.g1, d.g2, d.g3, d.tc, fast !== false);
  return true;
}

function getCollectionDefaultGradient() {
  var wrap = document.querySelector('.aw-collection-wrap');
  return gradientDataFromElement(wrap) || DG;
}

function applyCollectionDefaultGradient(fast) {
  var d = getCollectionDefaultGradient();
  setGradient(d.g1, d.g2, d.g3, d.tc, fast !== false);
}

// Shopify's theme editor can re-render sections after DOMContentLoaded. Delegated
// listeners keep hover/tap working on the first load and after every section reload.
var awFloatingDelegatesAttached = false;
function attachFloatingDelegates() {
  if (awFloatingDelegatesAttached) return;
  awFloatingDelegatesAttached = true;

  // Precise hover: many product PNGs are exported on square transparent canvases,
  // so the link rectangle can be much larger than the visible hoodie. We only
  // trigger the gradient when the cursor is inside a tightened inner hitbox.
  var activeFloatingHover = null;

  function getHitboxInset(el) {
    var raw = el.getAttribute('data-hitbox-inset');
    var n = raw === null || raw === '' ? 22 : parseFloat(raw);
    if (isNaN(n)) n = 22;
    return Math.max(0, Math.min(45, n));
  }

  function isInsidePreciseHitbox(el, x, y) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var inset = getHitboxInset(el) / 100;
    var ix = r.width * inset;
    var iy = r.height * inset;
    return x >= r.left + ix && x <= r.right - ix && y >= r.top + iy && y <= r.bottom - iy;
  }

  document.addEventListener('mousemove', function(e) {
    var el = e.target.closest && e.target.closest('.aw-floating-product');

    if (!el) {
      if (activeFloatingHover) {
        activeFloatingHover = null;
        resetDefaultGradient();
      }
      return;
    }

    if (isInsidePreciseHitbox(el, e.clientX, e.clientY)) {
      if (activeFloatingHover !== el) {
        activeFloatingHover = el;
        applyFloatingGradient(el, true);
      }
    } else if (activeFloatingHover === el) {
      activeFloatingHover = null;
      resetDefaultGradient();
    }
  });

  document.addEventListener('focusin', function(e) {
    var el = e.target.closest && e.target.closest('.aw-floating-product');
    if (!el) return;
    activeFloatingHover = el;
    applyFloatingGradient(el, true);
  });

  document.addEventListener('focusout', function(e) {
    var el = e.target.closest && e.target.closest('.aw-floating-product');
    if (!el) return;
    activeFloatingHover = null;
    resetDefaultGradient();
  });

  document.addEventListener('touchstart', function(e) {
    var el = e.target.closest && e.target.closest('.aw-floating-product');
    if (!el) return;
    // On touch there is no hover cursor, so tapping the product area previews its world.
    activeFloatingHover = el;
    applyFloatingGradient(el, true);
  }, { passive: true });

  document.addEventListener('mouseout', function(e) {
    var el = e.target.closest && e.target.closest('.aw-floating-product');
    if (!el) return;
    // Don't reset when moving between the product link and its child image/label.
    if (el.contains(e.relatedTarget)) return;
    if (activeFloatingHover === el) activeFloatingHover = null;
    resetDefaultGradient();
  });
}


/* ═══ COLLECTION CARDS — hover/touch gradient ═══ */
var awCollectionDelegatesAttached = false;
function attachCollectionDelegates() {
  if (awCollectionDelegatesAttached) return;
  awCollectionDelegatesAttached = true;
  var activeCollectionCard = null;

  document.addEventListener('mouseover', function(e) {
    var card = e.target.closest && e.target.closest('.aw-coll-card');
    if (!card) return;
    if (activeCollectionCard !== card) {
      activeCollectionCard = card;
      applyElementGradient(card, false);
    }
  });

  document.addEventListener('focusin', function(e) {
    var card = e.target.closest && e.target.closest('.aw-coll-card');
    if (!card) return;
    activeCollectionCard = card;
    applyElementGradient(card, false);
  });

  document.addEventListener('touchstart', function(e) {
    var card = e.target.closest && e.target.closest('.aw-coll-card');
    if (!card) return;
    activeCollectionCard = card;
    applyElementGradient(card, false);
  }, { passive: true });

  document.addEventListener('mouseout', function(e) {
    var card = e.target.closest && e.target.closest('.aw-coll-card');
    if (!card) return;
    if (card.contains(e.relatedTarget)) return;
    if (activeCollectionCard === card) activeCollectionCard = null;
    applyCollectionDefaultGradient(false);
  });

  document.addEventListener('focusout', function(e) {
    var card = e.target.closest && e.target.closest('.aw-coll-card');
    if (!card) return;
    if (activeCollectionCard === card) activeCollectionCard = null;
    applyCollectionDefaultGradient(false);
  });
}

function initCollection() {
  var wrap = document.querySelector('.aw-collection-wrap');
  if (!wrap) return;
  attachCollectionDelegates();
  applyCollectionDefaultGradient(false);
}

function initMobileHomeShowcase() {
  var showcase = document.querySelector('.aw-mobile-home-showcase');
  if (!showcase) return;

  var slides = showcase.querySelectorAll('.aw-mobile-home-slide');
  if (!slides.length) return;

  // Apply the first visible slide immediately on mobile so the first product
  // has the correct color world before the user scrolls.
  if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
    applyElementGradient(slides[0], true);
  }

  if (showcase.dataset.awMobileShowcaseBound === 'true') return;
  showcase.dataset.awMobileShowcaseBound = 'true';

  if ('IntersectionObserver' in window) {
    var activeSlide = null;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.55) return;
        if (activeSlide === entry.target) return;
        activeSlide = entry.target;
        applyElementGradient(entry.target, false);
      });
    }, { root: showcase, threshold: [0.55, 0.7, 0.9] });

    for (var i = 0; i < slides.length; i++) io.observe(slides[i]);
  } else {
    showcase.addEventListener('scroll', function() {
      var mid = showcase.scrollTop + showcase.clientHeight / 2;
      var closest = null;
      var best = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var center = slides[i].offsetTop + slides[i].offsetHeight / 2;
        var dist = Math.abs(center - mid);
        if (dist < best) { best = dist; closest = slides[i]; }
      }
      if (closest) applyElementGradient(closest, false);
    }, { passive: true });
  }
}

function initHome() {
  applyDefaultGradient(true);
  attachFloatingDelegates();
  initMobileHomeShowcase();
  var wrap = document.getElementById('aw-parallax-wrap');
  if (!wrap) return;
  if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) stopP();
  else startP();
}

/* ═══ NAV ═══ */
function initNav() {
  var nav = document.getElementById('aw-nav');
  var ob = document.getElementById('aw-btn-menu');
  var cb = document.getElementById('aw-btn-nav-close');
  if (ob && nav) ob.addEventListener('click', function(e) { e.preventDefault(); nav.classList.add('on'); });
  if (cb && nav) cb.addEventListener('click', function() { nav.classList.remove('on'); });
  if (nav) {
    var links = nav.querySelectorAll('.aw-nav-item');
    for (var i = 0; i < links.length; i++) links[i].addEventListener('click', function() { nav.classList.remove('on'); });
  }
}

/* ═══ CART (Ajax) ═══ */
function openCart() {
  var d = document.getElementById('aw-cart'), o = document.getElementById('aw-cart-overlay');
  document.documentElement.classList.add('aw-cart-is-open');
  if (document.body) document.body.classList.add('aw-cart-is-open');
  if (d) d.classList.add('on');
  if (o) o.classList.add('on');
  refreshCart();
}
function closeCart() {
  var d = document.getElementById('aw-cart'), o = document.getElementById('aw-cart-overlay');
  if (d) d.classList.remove('on');
  if (o) o.classList.remove('on');
  document.documentElement.classList.remove('aw-cart-is-open');
  if (document.body) document.body.classList.remove('aw-cart-is-open');
}
function refreshCart() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(renderCart).catch(function() {});
}
function renderCart(cart) {
  var counts = document.querySelectorAll('.aw-cart-count');
  for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;

  var body = document.getElementById('aw-cart-body');
  var ft = document.getElementById('aw-cart-ft');
  if (!body) return;

  if (!cart.items.length) {
    body.innerHTML = '<div class="aw-cart-empty"><p class="aw-cart-empty-txt">Your cart is empty.</p><a href="/collections/all" class="aw-cart-browse">Browse the Drop</a></div>';
    if (ft) ft.style.display = 'none';
    return;
  }

  var h = '<div class="aw-cart-items">';
  for (var j = 0; j < cart.items.length; j++) {
    var it = cart.items[j];
    var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_small$1') : '';
    var pr = (it.final_line_price / 100).toFixed(2);
    var vt = it.variant_title || '';
    h += '<div class="aw-ci">'
      + '<div class="aw-ci-img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>'
      + '<div class="aw-ci-info"><p class="aw-ci-name">' + it.product_title + '</p>'
      + (vt ? '<p class="aw-ci-var">' + vt + '</p>' : '')
      + '<div class="aw-ci-qty-wrap">'
      + '<button class="aw-ci-qty-btn" data-key="' + it.key + '" data-act="minus">\u2212</button>'
      + '<span class="aw-ci-qty-num">' + it.quantity + '</span>'
      + '<button class="aw-ci-qty-btn" data-key="' + it.key + '" data-act="plus">+</button>'
      + '</div></div>'
      + '<p class="aw-ci-pr">$' + pr + '</p>'
      + '<button class="aw-ci-remove" data-key="' + it.key + '" data-act="remove" title="Remove">\u2715</button>'
      + '</div>';
  }
  h += '</div>';
  body.innerHTML = h;
  if (ft) {
    ft.style.display = 'block';
    var tot = ft.querySelector('.aw-cart-sub-amt');
    if (tot) tot.textContent = '$' + (cart.total_price / 100).toFixed(2);
  }

  var btns = body.querySelectorAll('.aw-ci-qty-btn,.aw-ci-remove');
  for (var k = 0; k < btns.length; k++) {
    btns[k].addEventListener('click', function() {
      var key = this.dataset.key, act = this.dataset.act;
      var row = this.closest('.aw-ci');
      var qn = row ? row.querySelector('.aw-ci-qty-num') : null;
      var qty = qn ? parseInt(qn.textContent) : 1;
      if (act === 'minus') qty = Math.max(0, qty - 1);
      else if (act === 'plus') qty++;
      else qty = 0;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); }).then(renderCart).catch(function() {});
    });
  }
}

function initCart() {
  var ob = document.getElementById('aw-btn-cart');
  var cb = document.getElementById('aw-btn-x-cart');
  var ov = document.getElementById('aw-cart-overlay');
  var drawer = document.getElementById('aw-cart');
  if (ob && ob.dataset.awCartOpenBound !== 'true') {
    ob.dataset.awCartOpenBound = 'true';
    ob.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); openCart(); });
  }
  if (cb && cb.dataset.awCartCloseBound !== 'true') {
    cb.dataset.awCartCloseBound = 'true';
    cb.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); closeCart(); });
  }
  if (ov && ov.dataset.awCartOverlayBound !== 'true') {
    ov.dataset.awCartOverlayBound = 'true';
    ov.addEventListener('click', function(e) { e.preventDefault(); closeCart(); });
  }
  if (drawer && drawer.dataset.awCartDrawerBound !== 'true') {
    drawer.dataset.awCartDrawerBound = 'true';
    drawer.addEventListener('click', function(e) { e.stopPropagation(); });
  }
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeCart(); });
  window.awOpenCart = openCart;
  window.awCloseCart = closeCart;
  window.awRefreshCart = refreshCart;
}

/* ═══ PRODUCT PAGE ═══ */
function initPDP() {
  var form = document.getElementById('aw-product-form');
  if (!form) return;
  if (form.dataset.awPdpBound === 'true') return;
  form.dataset.awPdpBound = 'true';

  var pdpWrap = document.querySelector('.aw-pdp-wrap');
  if (pdpWrap) {
    var initialVariantKey = pdpWrap.getAttribute('data-current-variant-key') || '';
    var productKey = pdpWrap.getAttribute('data-product-color-key') || '';
    var didInfer = applyColorWorldFromText(initialVariantKey, true) || applyColorWorldFromText(productKey, true);
    if (!didInfer) {
      var pg1 = pdpWrap.getAttribute('data-gradient-1');
      var pg2 = pdpWrap.getAttribute('data-gradient-2');
      var pg3 = pdpWrap.getAttribute('data-gradient-3');
      var ptc = pdpWrap.getAttribute('data-text-color') || '#ffffff';
      if (pg1 && pg2 && pg3) setGradient(pg1, pg2, pg3, ptc, true);
    }
  }

  var mainImg = document.getElementById('aw-pdp-img');
  var thumbs = document.querySelectorAll('.aw-pdp-thumb');
  var curSlide = 0;

  function normalizeSrc(src) {
    if (!src) return '';
    try {
      // Shopify may swap between protocol-relative, absolute, and resized URLs.
      // Normalizing keeps the lightbox tied to the image the customer actually clicked.
      var u = new URL(src, window.location.href);
      return u.href.split('?')[0];
    } catch (e) {
      return String(src).split('?')[0];
    }
  }

  function getGallerySources() {
    var srcs = [];
    for (var i = 0; i < thumbs.length; i++) {
      var s = thumbs[i].dataset.fullSrc || thumbs[i].dataset.src;
      if (s && srcs.indexOf(s) === -1) srcs.push(s);
    }
    if (!srcs.length && mainImg && mainImg.src) srcs.push(mainImg.src);
    return srcs;
  }

  function findGalleryIndexBySrc(src) {
    var srcs = getGallerySources();
    var n = normalizeSrc(src);
    for (var i = 0; i < srcs.length; i++) {
      if (normalizeSrc(srcs[i]) === n) return i;
    }
    return -1;
  }

  function setPDPImage(index, instant) {
    var srcs = getGallerySources();
    if (!srcs.length || !mainImg) return;
    curSlide = ((index % srcs.length) + srcs.length) % srcs.length;
    var src = srcs[curSlide];

    function commitImage() {
      mainImg.src = src;
      mainImg.dataset.fullSrc = src;
      mainImg.dataset.galleryIndex = String(curSlide);
      mainImg.style.opacity = '1';
      mainImg.style.filter = 'blur(0)';
    }

    if (instant) {
      commitImage();
    } else {
      mainImg.style.opacity = '0';
      mainImg.style.filter = 'blur(14px)';
      setTimeout(commitImage, 180);
    }

    for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('on', j === curSlide);
    updateLightboxImage();
  }

  // Thumbnails should select the exact clicked image. The fullscreen zoom then opens
  // whatever image is currently displayed, rather than a separate/forced override set.
  for (var i = 0; i < thumbs.length; i++) {
    thumbs[i].dataset.galleryIndex = String(i);
    (function(idx) {
      thumbs[idx].addEventListener('click', function() {
        setPDPImage(idx, false);
      });
    })(i);
  }

  // Product image wheel is handled by the V7 scroll-safe controller near the end of this file.

  // Fullscreen image lightbox
  var lightbox = document.getElementById('aw-pdp-lightbox');
  var lightboxImg = document.getElementById('aw-pdp-lightbox-img');
  var lightboxCount = document.getElementById('aw-pdp-lightbox-count');
  var lightboxClose = lightbox ? lightbox.querySelector('.aw-pdp-lightbox-close') : null;
  var lightboxPrev = lightbox ? lightbox.querySelector('.aw-pdp-lightbox-prev') : null;
  var lightboxNext = lightbox ? lightbox.querySelector('.aw-pdp-lightbox-next') : null;

  function updateLightboxImage(srcOverride) {
    if (!lightbox || !lightbox.classList.contains('open') || !lightboxImg) return;
    var srcs = getGallerySources();
    var src = srcOverride || (srcs.length ? srcs[curSlide] : (mainImg ? (mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src) : ''));
    if (!src) return;
    lightboxImg.src = src;
    if (lightboxCount) {
      var idx = findGalleryIndexBySrc(src);
      lightboxCount.textContent = idx >= 0 && srcs.length ? ((idx + 1) + ' / ' + srcs.length) : '';
    }
  }

  function openLightbox(target) {
    if (!lightbox) return;
    var src = '';
    if (typeof target === 'number') {
      setPDPImage(target, true);
      src = getGallerySources()[curSlide];
    } else if (typeof target === 'string') {
      var idx = findGalleryIndexBySrc(target);
      if (idx >= 0) {
        setPDPImage(idx, true);
        src = getGallerySources()[curSlide];
      } else {
        src = target;
      }
    } else if (mainImg) {
      src = mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src;
      var currentIdx = findGalleryIndexBySrc(src);
      if (currentIdx >= 0) curSlide = currentIdx;
    }
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('aw-lightbox-open');
    updateLightboxImage(src);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aw-lightbox-open');
  }

  if (mainImg) {
    mainImg.setAttribute('role', 'button');
    mainImg.setAttribute('tabindex', '0');
    mainImg.dataset.fullSrc = mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src || '';
    mainImg.dataset.galleryIndex = String(curSlide);
    mainImg.addEventListener('click', function() {
      openLightbox(mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src);
    });
    mainImg.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openLightbox(mainImg.dataset.fullSrc || mainImg.currentSrc || mainImg.src);
      }
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function(e) { e.stopPropagation(); setPDPImage(curSlide - 1, true); });
  if (lightboxNext) lightboxNext.addEventListener('click', function(e) { e.stopPropagation(); setPDPImage(curSlide + 1, true); });
  if (lightbox) {
    lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });
  }
  document.addEventListener('keydown', function(e) {
    if (!lightbox || !lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') setPDPImage(curSlide - 1, true);
    if (e.key === 'ArrowRight') setPDPImage(curSlide + 1, true);
  });

  var touchStartX = null;
  if (lightbox) {
    lightbox.addEventListener('touchstart', function(e) { touchStartX = e.touches && e.touches.length ? e.touches[0].clientX : null; }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      if (touchStartX === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 44) setPDPImage(curSlide + (dx < 0 ? 1 : -1), true);
      touchStartX = null;
    }, { passive: true });
  }

  // Variant selection
  var vid = document.getElementById('aw-variant-id');
  var variants = window.awVariants || [];
  var opts = form.querySelectorAll('[data-aw-option]');

  function updateVariant() {
    var sel = {};
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].classList.contains('on') || opts[i].checked) {
        sel[opts[i].dataset.awOption] = opts[i].dataset.awValue;
      }
    }
    var match = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j], ok = true;
      for (var k = 0; k < v.options.length; k++) {
        var key = 'option' + (k + 1);
        if (sel[key] && sel[key] !== v.options[k]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    if (match && vid) {
      vid.value = match.id;
      var pe = document.querySelector('.aw-atc-price');
      if (pe) pe.textContent = '$' + (match.price / 100).toFixed(2);
      var ab = document.getElementById('aw-pdp-atc');
      if (ab) {
        var sp = ab.querySelector('span:first-child');
        if (match.available) { ab.disabled = false; if (sp) sp.textContent = 'ADD TO CART'; }
        else { ab.disabled = true; if (sp) sp.textContent = 'SOLD OUT'; }
      }

      // If color is a variant option, make the PDP world follow the selected color.
      var selectedText = (match.title || '') + ' ';
      for (var sk in sel) selectedText += ' ' + sel[sk];
      applyColorWorldFromText(selectedText, true);
    }
  }

  for (var i = 0; i < opts.length; i++) {
    opts[i].addEventListener('click', function() {
      var grp = this.dataset.awOption;
      var siblings = form.querySelectorAll('[data-aw-option="' + grp + '"]');
      for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('on');
      this.classList.add('on');
      // Update label
      var g = this.closest('.aw-opt-group');
      if (g) { var vl = g.querySelector('.aw-opt-val'); if (vl) vl.textContent = ' [ ' + this.dataset.awValue + ' ]'; }
      updateVariant();
    });
  }

  // Add to cart
  var atc = document.getElementById('aw-pdp-atc');
  function awAddCurrentVariantToCart(e) {
    if (e) e.preventDefault();
    var id = vid ? vid.value : null;
    if (!id || (atc && atc.disabled)) return;
    var orig = atc ? atc.innerHTML : '';
    if (atc) atc.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id), quantity: 1 }] })
    }).then(function(r) { return r.json(); }).then(function() {
      if (atc) {
        var pp = document.querySelector('.aw-atc-price');
        atc.innerHTML = '<span>ADDED \u2713</span><span class="aw-atc-price">' + (pp ? pp.textContent : '') + '</span>';
        setTimeout(function() { atc.innerHTML = orig; atc.disabled = false; }, 1400);
      }
      refreshCart();
      openCart();
    }).catch(function() { if (atc) atc.disabled = false; });
  }

  if (atc && atc.dataset.awAtcBound !== 'true') {
    atc.dataset.awAtcBound = 'true';
    atc.addEventListener('click', awAddCurrentVariantToCart);
  }
  if (form && form.dataset.awSubmitBound !== 'true') {
    form.dataset.awSubmitBound = 'true';
    form.addEventListener('submit', awAddCurrentVariantToCart);
  }
}



/* ═══ FAQ ACCORDION ═══ */
function initFAQ() {
  var lists = document.querySelectorAll('.aw-faq-list');
  if (!lists.length) return;
  for (var i = 0; i < lists.length; i++) {
    var list = lists[i];
    if (list.dataset.awFaqBound === 'true') continue;
    list.dataset.awFaqBound = 'true';
    list.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('.aw-faq-q');
      if (!btn) return;
      var item = btn.closest('.aw-faq-item');
      var parent = btn.closest('.aw-faq-list');
      if (!item || !parent) return;
      var willOpen = !item.classList.contains('open');
      if (parent.getAttribute('data-aw-accordion-single') === 'true') {
        var openItems = parent.querySelectorAll('.aw-faq-item.open');
        for (var j = 0; j < openItems.length; j++) {
          openItems[j].classList.remove('open');
          var ob = openItems[j].querySelector('.aw-faq-q');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        }
      }
      item.classList.toggle('open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  }
}

/* ═══ IMAGE FALLBACKS — avoid visible broken alt text ═══ */
function initImageFallbacks() {
  if (window.awImageFallbacksAttached) return;
  window.awImageFallbacksAttached = true;
  document.addEventListener('error', function(e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    if (!img.closest('.aw-pdp-wrap,.aw-home-wrap,.aw-collection-wrap,.aw-cart')) return;
    img.style.display = 'none';
    var stage = img.closest('.aw-pdp-stage');
    if (stage && !stage.querySelector('.aw-img-placeholder')) {
      var ph = document.createElement('div');
      ph.className = 'aw-img-placeholder aw-pdp-placeholder';
      ph.innerHTML = '<span>Upload transparent product image</span>';
      stage.appendChild(ph);
    }
  }, true);
}

/* ═══ INIT ═══ */
document.addEventListener('DOMContentLoaded', function() {
  initImageFallbacks();
  initNav();
  initCart();
  initHome();
  initCollection();
  initPDP();
  initFAQ();
  refreshCart();
});

// Shopify Theme Editor support: sections can be injected/reloaded after the first
// page load. Re-read default gradient and restart lightweight homepage behavior.
document.addEventListener('shopify:section:load', function() {
  initImageFallbacks();
  initHome();
  initCollection();
  initPDP();
  initFAQ();
});
document.addEventListener('shopify:section:select', function() {
  initImageFallbacks();
  initHome();
  initCollection();
  initPDP();
  initFAQ();
});
document.addEventListener('shopify:section:deselect', function() {
  applyDefaultGradient(true);
});
})();

// ASWEARE size guide modal — open chart in-page instead of navigating to raw image URL
(function() {
  function initSizeGuideModal() {
    var modal = document.getElementById('aw-size-guide-modal');
    var img = document.getElementById('aw-size-guide-img');
    if (!modal || !img) return;

    function open(src) {
      if (!src) return;
      img.src = src;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('aw-size-guide-open');
    }

    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('aw-size-guide-open');
    }

    document.querySelectorAll('[data-aw-size-guide-open]').forEach(function(btn) {
      if (btn.dataset.awSizeGuideBound === 'true') return;
      btn.dataset.awSizeGuideBound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        open(btn.getAttribute('data-size-guide-src'));
      });
    });

    document.querySelectorAll('[data-aw-size-guide-close]').forEach(function(btn) {
      if (btn.dataset.awSizeGuideCloseBound === 'true') return;
      btn.dataset.awSizeGuideCloseBound = 'true';
      btn.addEventListener('click', close);
    });

    if (modal.dataset.awSizeGuideModalBound !== 'true') {
      modal.dataset.awSizeGuideModalBound = 'true';
      modal.addEventListener('click', function(e) {
        if (e.target === modal) close();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) close();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideModal);
  } else {
    initSizeGuideModal();
  }
  document.addEventListener('shopify:section:load', initSizeGuideModal);
  document.addEventListener('shopify:section:select', initSizeGuideModal);
})();

/* ═══ ASWEARE V5 CLICK RESCUE + ROBUST PDP BINDINGS ═══
   Works even if a transparent layer accidentally becomes the event target. */
(function(){
  function closestFromPoint(e, selector) {
    var direct = e.target && e.target.closest ? e.target.closest(selector) : null;
    if (direct) return direct;
    if (!document.elementsFromPoint) return null;
    var stack = document.elementsFromPoint(e.clientX, e.clientY) || [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el && el.closest) {
        var found = el.closest(selector);
        if (found) return found;
      }
    }
    return null;
  }

  function getPDPForm(){ return document.getElementById('aw-product-form'); }
  function getVariantInput(){ return document.getElementById('aw-variant-id'); }

  function findVariantForCurrentOptions() {
    var form = getPDPForm();
    var variants = window.awVariants || [];
    if (!form || !variants.length) return null;
    var opts = form.querySelectorAll('[data-aw-option]');
    var sel = {};
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].classList.contains('on') || opts[i].checked) {
        sel[opts[i].dataset.awOption] = opts[i].dataset.awValue;
      }
    }
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j], ok = true;
      for (var k = 0; k < v.options.length; k++) {
        var key = 'option' + (k + 1);
        if (sel[key] && sel[key] !== v.options[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function selectPDPOption(btn) {
    var form = getPDPForm();
    if (!form || !btn || !btn.dataset || !btn.dataset.awOption) return;
    var grp = btn.dataset.awOption;
    var siblings = form.querySelectorAll('[data-aw-option="' + grp + '"]');
    for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('on');
    btn.classList.add('on');
    var g = btn.closest('.aw-opt-group');
    if (g) {
      var vl = g.querySelector('.aw-opt-val');
      if (vl) vl.textContent = ' [ ' + btn.dataset.awValue + ' ]';
    }
    var match = findVariantForCurrentOptions();
    var vid = getVariantInput();
    if (match && vid) {
      vid.value = match.id;
      var pe = document.querySelector('.aw-atc-price');
      if (pe) pe.textContent = '$' + (match.price / 100).toFixed(2);
      var atc = document.getElementById('aw-pdp-atc');
      if (atc) {
        var sp = atc.querySelector('span:first-child');
        atc.disabled = !match.available;
        if (sp) sp.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (typeof applyColorWorldFromText === 'function') {
        var txt = (match.title || '') + ' ' + (match.options || []).join(' ');
        applyColorWorldFromText(txt, true);
      }
    }
  }

  function addCurrentVariant() {
    var vid = getVariantInput();
    var atc = document.getElementById('aw-pdp-atc');
    var id = vid ? vid.value : null;
    if (!id || (atc && atc.disabled)) return;
    var original = atc ? atc.innerHTML : '';
    if (atc) atc.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function(r){ return r.json(); }).then(function(){
      if (atc) {
        var price = document.querySelector('.aw-atc-price');
        atc.innerHTML = '<span>ADDED ✓</span><span class="aw-atc-price">' + (price ? price.textContent : '') + '</span>';
        setTimeout(function(){ atc.innerHTML = original; atc.disabled = false; }, 1200);
      }
      if (typeof window.awRefreshCart === 'function') window.awRefreshCart();
      if (typeof window.awOpenCart === 'function') window.awOpenCart();
    }).catch(function(){
      if (atc) atc.disabled = false;
      var form = getPDPForm();
      if (form) form.submit();
    });
  }

  // Capture-level handler: rescues clicks even if the wrong transparent layer is on top.
  document.addEventListener('click', function(e){
    var option = closestFromPoint(e, '.aw-sz, .aw-swatch');
    if (option) {
      e.preventDefault();
      e.stopPropagation();
      selectPDPOption(option);
      return;
    }

    var atc = closestFromPoint(e, '#aw-pdp-atc');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      addCurrentVariant();
      return;
    }

    var thumb = closestFromPoint(e, '.aw-pdp-thumb');
    if (thumb) {
      // Let the original thumbnail handler run when possible. This fallback handles blocked clicks.
      var all = Array.prototype.slice.call(document.querySelectorAll('.aw-pdp-thumb'));
      var idx = all.indexOf(thumb);
      var img = document.getElementById('aw-pdp-img');
      var src = thumb.dataset.fullSrc || thumb.dataset.src;
      if (idx >= 0 && img && src) {
        e.preventDefault();
        e.stopPropagation();
        img.src = src;
        img.dataset.fullSrc = src;
        for (var i = 0; i < all.length; i++) all[i].classList.toggle('on', i === idx);
      }
    }
  }, true);

  // Submit fallback for enter key / browser form submission.
  document.addEventListener('submit', function(e){
    var form = e.target && e.target.closest ? e.target.closest('#aw-product-form') : null;
    if (!form) return;
    e.preventDefault();
    addCurrentVariant();
  }, true);

  // Product image wheel is handled by the V7 scroll-safe controller near the end of this file.
})();

/* ═══ ASWEARE V7 — PDP GALLERY SCROLL RECOVERY FIX ═══
   The gallery can still change images with wheel/swipe, but it no longer traps
   the page at the footer or prevents normal scroll back up/down. */
(function(){
  if (window.awPdpGalleryScrollV7Bound) return;
  window.awPdpGalleryScrollV7Bound = true;

  var lastCycleAt = 0;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchStartedOnControls = false;

  function rootScroller(){
    return document.scrollingElement || document.documentElement || document.body;
  }

  function isProductPage(){
    return !!document.querySelector('.aw-pdp-wrap #aw-pdp-img');
  }

  function isBlockedTarget(target){
    return !!(target && target.closest && target.closest(
      '.aw-pdp-card, #aw-cart, #aw-nav, .aw-size-guide-modal.open, .aw-pdp-lightbox.open, .aw-header, input, textarea, select, button, a'
    ));
  }

  function getThumbs(){
    return Array.prototype.slice.call(document.querySelectorAll('.aw-pdp-thumb'));
  }

  function getCurrentIndex(thumbs){
    var idx = thumbs.findIndex(function(t){ return t.classList.contains('on'); });
    if (idx >= 0) return idx;
    var main = document.getElementById('aw-pdp-img');
    if (!main) return 0;
    var current = (main.dataset.fullSrc || main.currentSrc || main.src || '').split('?')[0];
    for (var i = 0; i < thumbs.length; i++) {
      var s = (thumbs[i].dataset.fullSrc || thumbs[i].dataset.src || '').split('?')[0];
      if (s && current && current.indexOf(s) !== -1) return i;
    }
    return 0;
  }

  function isOverGalleryZone(e){
    var target = e.target;
    if (target && target.closest && target.closest('.aw-pdp-main-img, .aw-pdp-stage, .aw-pdp-thumbs, .aw-pdp-thumb')) return true;
    if (!document.elementsFromPoint) return false;
    var stack = document.elementsFromPoint(e.clientX, e.clientY) || [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (!el || !el.classList) continue;
      if (el.classList.contains('aw-pdp-main-img') || el.classList.contains('aw-pdp-stage') || el.classList.contains('aw-pdp-thumbs') || el.classList.contains('aw-pdp-thumb')) return true;
    }
    return false;
  }

  function showGalleryIndex(next){
    var main = document.getElementById('aw-pdp-img');
    var thumbs = getThumbs();
    if (!main || thumbs.length < 2) return false;
    var index = ((next % thumbs.length) + thumbs.length) % thumbs.length;
    var src = thumbs[index].dataset.fullSrc || thumbs[index].dataset.src;
    if (!src) return false;

    main.style.opacity = '0';
    main.style.filter = 'blur(10px)';
    window.setTimeout(function(){
      main.src = src;
      main.dataset.fullSrc = src;
      main.dataset.galleryIndex = String(index);
      main.style.opacity = '1';
      main.style.filter = 'blur(0)';
    }, 80);

    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('on', i === index);
    return true;
  }

  function cycleGallery(direction){
    var now = Date.now();
    if (now - lastCycleAt < 260) return false;
    var thumbs = getThumbs();
    if (thumbs.length < 2) return false;
    lastCycleAt = now;
    var current = getCurrentIndex(thumbs);
    return showGalleryIndex(current + direction);
  }

  document.addEventListener('wheel', function(e){
    if (!isProductPage()) return;
    if (isBlockedTarget(e.target)) return;

    var root = rootScroller();
    var scrollTop = root.scrollTop || window.pageYOffset || 0;
    var amount = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
    if (Math.abs(amount) < 8) return;

    // Critical recovery rule:
    // once the page has actually moved down toward lower content/footer, never hijack
    // upward scrolling. This lets you always get back to the top.
    if (scrollTop > 24 && amount < 0) return;

    // Also do not hijack normal page scrolling unless the cursor is truly over
    // the product media/gallery zone. Empty background should scroll the page.
    if (!isOverGalleryZone(e)) return;

    var thumbs = getThumbs();
    var current = getCurrentIndex(thumbs);
    // Boundary release: at first image + scroll up, let the page scroll up.
    // At last image + scroll down, let the page continue down to footer/details.
    if (amount < 0 && current <= 0) return;
    if (amount > 0 && current >= thumbs.length - 1) return;

    e.preventDefault();
    e.stopPropagation();
    cycleGallery(amount > 0 ? 1 : -1);
  }, { passive: false, capture: true });

  // V12 note: touch/swipe gallery is now handled by the dedicated mobile PDP controller below.
  // Keeping the old document-level touch handler caused double-advancing / glitchy swipes
  // because both the document and the image stage changed the photo on the same gesture.
})();

/* ═══ ASWEARE V8 — SIZE GUIDE CLOSE RESCUE ═══
   Close the size chart at capture phase so no PDP click-rescue/gallery handler
   can trap the tap/click before the X receives it. */
(function(){
  if (window.awSizeGuideCloseRescueV8Bound) return;
  window.awSizeGuideCloseRescueV8Bound = true;

  function getModal(){ return document.getElementById('aw-size-guide-modal'); }
  function closeSizeGuide(){
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aw-size-guide-open');
  }

  function shouldCloseFromEvent(e){
    var target = e.target;
    if (!target) return false;
    if (target.closest && target.closest('[data-aw-size-guide-close], .aw-size-guide-close')) return true;
    var modal = getModal();
    return !!(modal && modal.classList.contains('open') && target === modal);
  }

  function handleClose(e){
    if (!shouldCloseFromEvent(e)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    closeSizeGuide();
  }

  document.addEventListener('pointerdown', handleClose, true);
  document.addEventListener('click', handleClose, true);
  document.addEventListener('touchstart', handleClose, { capture: true, passive: false });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeSizeGuide();
  }, true);
})();

/* ═══ ASWEARE V9 — MOBILE SCROLL GRADIENT SYNC ═══
   Mobile has no hover cursor. This makes the atmosphere follow the product
   closest to the center of the viewport while scrolling homepage/collection. */
(function(){
  if (window.awMobileScrollGradientV9Bound) return;
  window.awMobileScrollGradientV9Bound = true;

  var lastKey = '';
  var raf = null;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : { matches: false };

  function isMobile(){ return !!mq.matches; }

  function setFromElement(el){
    if (!el || !window.awSetGradient) return;
    var g1 = el.getAttribute('data-gradient-1');
    var g2 = el.getAttribute('data-gradient-2');
    var g3 = el.getAttribute('data-gradient-3');
    var tc = el.getAttribute('data-text-color') || '#ffffff';
    if (!g1 || !g2 || !g3) return;
    var key = g1 + '|' + g2 + '|' + g3 + '|' + tc;
    if (key === lastKey) return;
    lastKey = key;
    window.awSetGradient(g1, g2, g3, tc, false);
  }

  function scoreElement(el){
    var r = el.getBoundingClientRect();
    if (r.bottom <= 0 || r.top >= window.innerHeight) return Infinity;
    if (r.right <= 0 || r.left >= window.innerWidth) return Infinity;

    var viewportCenterY = window.innerHeight * 0.52;
    var viewportCenterX = window.innerWidth * 0.5;
    var elCenterY = r.top + r.height / 2;
    var elCenterX = r.left + r.width / 2;

    // Vertical center matters most. Horizontal center helps on 2-column shop grids.
    return Math.abs(elCenterY - viewportCenterY) + Math.abs(elCenterX - viewportCenterX) * 0.35;
  }

  function closestVisible(selector){
    var els = Array.prototype.slice.call(document.querySelectorAll(selector));
    var best = null;
    var bestScore = Infinity;
    for (var i = 0; i < els.length; i++) {
      var s = scoreElement(els[i]);
      if (s < bestScore) {
        bestScore = s;
        best = els[i];
      }
    }
    return best;
  }

  function update(){
    raf = null;
    if (!isMobile()) return;

    // Homepage mobile: one product per vertical scene.
    var home = document.querySelector('.aw-mobile-home-showcase');
    if (home) {
      var slide = closestVisible('.aw-mobile-home-slide[data-gradient-1]');
      if (slide) { setFromElement(slide); return; }
    }

    // Collection/shop page mobile: follow the product card nearest the viewport center.
    var collection = document.querySelector('.aw-collection-wrap');
    if (collection) {
      var card = closestVisible('.aw-coll-card[data-gradient-1]');
      if (card) { setFromElement(card); return; }
    }
  }

  function schedule(){
    if (raf) return;
    raf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(schedule, 250); }, { passive: true });
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(schedule, 120); });
  document.addEventListener('shopify:section:load', function(){ lastKey = ''; setTimeout(schedule, 120); });
  document.addEventListener('shopify:section:select', function(){ lastKey = ''; setTimeout(schedule, 120); });

  // Re-run after images/fonts settle, because card positions can shift after load.
  window.addEventListener('load', function(){ setTimeout(schedule, 250); }, { passive: true });
  setTimeout(schedule, 350);
})();

/* ═══ ASWEARE V10 — MOBILE PDP BOTTOM SHEET + HORIZONTAL GALLERY SWIPE ═══ */
(function(){
  if (window.awPdpMobileSheetV10Bound) return;
  window.awPdpMobileSheetV10Bound = true;

  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; }
  function isPdp(){ return !!document.querySelector('.aw-pdp-wrap #aw-pdp-img'); }
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function getThumbs(){ return Array.prototype.slice.call(document.querySelectorAll('.aw-pdp-thumb')); }
  function currentIndex(thumbs){
    var active = thumbs.findIndex(function(t){ return t.classList.contains('on'); });
    if (active >= 0) return active;
    var img = document.getElementById('aw-pdp-img');
    var idx = img && img.dataset.galleryIndex ? parseInt(img.dataset.galleryIndex, 10) : 0;
    return isNaN(idx) ? 0 : idx;
  }
  function showIndex(index){
    var img = document.getElementById('aw-pdp-img');
    var thumbs = getThumbs();
    if (!img || thumbs.length < 2) return false;
    var next = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    var src = thumbs[next].dataset.fullSrc || thumbs[next].dataset.src || (thumbs[next].querySelector('img') && thumbs[next].querySelector('img').src);
    if (!src) return false;
    img.style.opacity = '0';
    img.style.filter = 'blur(8px)';
    window.setTimeout(function(){
      img.src = src;
      img.dataset.fullSrc = src;
      img.dataset.galleryIndex = String(next);
      img.style.opacity = '1';
      img.style.filter = 'blur(0)';
    }, 70);
    thumbs.forEach(function(t, i){ t.classList.toggle('on', i === next); });
    return true;
  }
  function cycleGallery(dir){
    var thumbs = getThumbs();
    if (thumbs.length < 2) return false;
    return showIndex(currentIndex(thumbs) + dir);
  }

  function setupSheet(){
    if (!isPdp()) return;
    var card = document.querySelector('.aw-pdp-card');
    if (!card || card.querySelector('.aw-pdp-sheet-handle')) return;

    var handle = document.createElement('button');
    handle.type = 'button';
    handle.className = 'aw-pdp-sheet-handle';
    handle.setAttribute('aria-label', 'Tap or drag product details');
    handle.dataset.label = 'tap or drag to hide details';
    card.insertBefore(handle, card.firstChild);

    function setState(state){
      card.classList.toggle('aw-sheet-expanded', state === 'expanded');
      card.classList.toggle('aw-sheet-collapsed', state === 'collapsed');
      card.dataset.sheetState = state;
      document.body.classList.toggle('aw-pdp-sheet-is-collapsed', state === 'collapsed');
      document.body.classList.toggle('aw-pdp-sheet-is-expanded', state === 'expanded');
      if (handle) {
        handle.dataset.label = state === 'collapsed' ? 'tap for product details' : (state === 'expanded' ? 'tap or drag down' : 'tap or drag to hide details');
        handle.setAttribute('aria-expanded', state === 'collapsed' ? 'false' : 'true');
      }
    }
    if (!card.dataset.sheetState) setState('default');

    var startY = 0;
    var dragging = false;
    var moved = false;

    function yFromEvent(e){
      if (e.touches && e.touches.length) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientY;
      return e.clientY || 0;
    }
    function start(e){
      if (!isMobile()) return;
      dragging = true;
      moved = false;
      startY = yFromEvent(e);
      card.classList.add('aw-sheet-dragging');
      e.preventDefault();
    }
    function move(e){
      if (!dragging) return;
      var dy = yFromEvent(e) - startY;
      if (Math.abs(dy) > 6) moved = true;
      var limited = Math.max(-120, Math.min(220, dy));
      card.style.transform = 'translateY(' + limited + 'px)';
      e.preventDefault();
    }
    function end(e){
      if (!dragging) return;
      dragging = false;
      var dy = yFromEvent(e) - startY;
      card.classList.remove('aw-sheet-dragging');
      card.style.transform = '';
      if (!moved) {
        var cur = card.dataset.sheetState || 'default';
        setState(cur === 'collapsed' ? 'default' : (cur === 'expanded' ? 'default' : 'collapsed'));
        return;
      }
      if (dy > 48) setState('collapsed');
      else if (dy < -48) setState('expanded');
      else setState('default');
      e.preventDefault();
    }

    handle.addEventListener('mousedown', start, { passive: false });
    document.addEventListener('mousemove', move, { passive: false });
    document.addEventListener('mouseup', end, { passive: false });
    handle.addEventListener('touchstart', start, { passive: false });
    document.addEventListener('touchmove', move, { passive: false });
    document.addEventListener('touchend', end, { passive: false });

    // When a customer taps any product control, bring the sheet back if it was hidden.
    card.addEventListener('click', function(e){
      if (card.classList.contains('aw-sheet-collapsed') && !e.target.closest('.aw-pdp-sheet-handle')) setState('default');
    }, true);
  }

  function setupMobileGallerySwipe(){
    // V12 replaces the V10 swipe handler with a stricter mobile controller.
    return;
  }

  ready(function(){
    setupSheet();
    setupMobileGallerySwipe();
  });
  window.addEventListener('resize', function(){
    setupSheet();
    setupMobileGallerySwipe();
  }, { passive: true });
})();

/* ═══ ASWEARE V12 — MOBILE PDP GALLERY CONTROLS + SIZE GUIDE RESCUE ═══
   Fixes: glitchy mobile photo swipes, unclear gallery controls, and size chart
   not opening on mobile because PDP layers can steal the tap. */
(function(){
  if (window.awPdpMobileV12Bound) return;
  window.awPdpMobileV12Bound = true;

  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; }
  function isPdp(){ return !!document.querySelector('.aw-pdp-wrap #aw-pdp-img'); }
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function thumbs(){ return qa('.aw-pdp-thumb'); }
  function currentIndex(){
    var t = thumbs();
    var active = t.findIndex(function(el){ return el.classList.contains('on'); });
    if (active >= 0) return active;
    var img = q('#aw-pdp-img');
    var n = img && img.dataset.galleryIndex ? parseInt(img.dataset.galleryIndex, 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function setIndex(i, userInitiated){
    var img = q('#aw-pdp-img');
    var t = thumbs();
    if (!img || t.length < 1) return false;
    var next = ((i % t.length) + t.length) % t.length;
    var src = t[next].dataset.fullSrc || t[next].dataset.src || (q('img', t[next]) && q('img', t[next]).src);
    if (!src) return false;

    img.classList.add('aw-pdp-img-changing');
    window.setTimeout(function(){
      img.src = src;
      img.dataset.fullSrc = src;
      img.dataset.galleryIndex = String(next);
      t.forEach(function(el, idx){ el.classList.toggle('on', idx === next); });
      updateDots(next);
      window.setTimeout(function(){ img.classList.remove('aw-pdp-img-changing'); }, 90);
    }, userInitiated ? 35 : 0);
    return true;
  }
  function next(){ return setIndex(currentIndex() + 1, true); }
  function prev(){ return setIndex(currentIndex() - 1, true); }

  function updateDots(active){
    qa('.aw-pdp-mobile-dot').forEach(function(dot, idx){
      dot.classList.toggle('on', idx === active);
      dot.setAttribute('aria-current', idx === active ? 'true' : 'false');
    });
    var count = q('.aw-pdp-mobile-count');
    var t = thumbs();
    if (count && t.length) count.textContent = (active + 1) + ' / ' + t.length;
  }

  function buildMobileGalleryUI(){
    if (!isPdp()) return;
    var stage = q('.aw-pdp-stage');
    var t = thumbs();
    if (!stage || t.length < 2) return;
    if (q('.aw-pdp-mobile-gallery-ui', stage)) {
      updateDots(currentIndex());
      return;
    }

    var ui = document.createElement('div');
    ui.className = 'aw-pdp-mobile-gallery-ui';
    ui.innerHTML = '<button type="button" class="aw-pdp-mobile-arrow aw-prev" aria-label="Previous product photo">‹</button>' +
      '<div class="aw-pdp-mobile-mid"><span class="aw-pdp-mobile-swipe-label">swipe or tap photos</span><div class="aw-pdp-mobile-dots"></div><span class="aw-pdp-mobile-count"></span></div>' +
      '<button type="button" class="aw-pdp-mobile-arrow aw-next" aria-label="Next product photo">›</button>';
    stage.appendChild(ui);

    var dots = q('.aw-pdp-mobile-dots', ui);
    t.forEach(function(_, idx){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aw-pdp-mobile-dot';
      b.setAttribute('aria-label', 'Show product photo ' + (idx + 1));
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setIndex(idx, true); });
      dots.appendChild(b);
    });

    q('.aw-prev', ui).addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); prev(); });
    q('.aw-next', ui).addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); next(); });
    updateDots(currentIndex());
  }

  function bindStableMobileSwipe(){
    if (!isPdp()) return;
    var stage = q('.aw-pdp-stage');
    if (!stage || stage.dataset.awV12SwipeBound === 'true') return;
    stage.dataset.awV12SwipeBound = 'true';

    var sx = 0, sy = 0, tracking = false, locked = null, lastSwipeAt = 0;
    function startedOnBlocked(target){
      return !!(target && target.closest && target.closest('.aw-pdp-card, .aw-pdp-sheet-handle, .aw-pdp-mobile-gallery-ui button, #aw-cart, #aw-nav, .aw-size-guide-modal.open, button, a, input, select, textarea'));
    }

    stage.addEventListener('touchstart', function(e){
      if (!isMobile() || !isPdp() || startedOnBlocked(e.target)) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      sx = t.clientX; sy = t.clientY; tracking = true; locked = null;
    }, { passive: true, capture: true });

    stage.addEventListener('touchmove', function(e){
      if (!tracking || !isMobile()) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (!locked && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        locked = Math.abs(dx) > Math.abs(dy) * 1.35 ? 'x' : 'y';
      }
      // Only when the gesture is clearly horizontal do we block native movement.
      // Vertical gestures remain native page scroll.
      if (locked === 'x') {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false, capture: true });

    stage.addEventListener('touchend', function(e){
      if (!tracking || !isMobile()) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t || locked !== 'x') return;
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
      var now = Date.now();
      if (now - lastSwipeAt < 260) return;
      lastSwipeAt = now;
      e.preventDefault();
      e.stopPropagation();
      dx < 0 ? next() : prev();
    }, { passive: false, capture: true });
  }

  function openSizeGuide(src){
    var modal = q('#aw-size-guide-modal');
    var img = q('#aw-size-guide-img');
    if (!modal || !img || !src) return false;
    // Move modal to body so it escapes product card / selected section stacking contexts.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    img.src = src;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('aw-size-guide-open');
    return true;
  }
  function closeSizeGuide(){
    var modal = q('#aw-size-guide-modal');
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aw-size-guide-open');
  }

  // Mobile size guide rescue: pointerup/touchend/click, capture phase, before PDP rescue.
  function sizeGuideEvent(e){
    var target = e.target;
    if (!target || !target.closest) return;
    var close = target.closest('[data-aw-size-guide-close], .aw-size-guide-close');
    if (close) {
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeSizeGuide(); return;
    }
    var open = target.closest('[data-aw-size-guide-open], .aw-pdp-size-guide');
    if (open) {
      var src = open.getAttribute('data-size-guide-src') || open.getAttribute('href');
      if (src) {
        e.preventDefault(); e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openSizeGuide(src);
      }
    }
  }

  document.addEventListener('pointerup', sizeGuideEvent, true);
  document.addEventListener('touchend', sizeGuideEvent, { capture: true, passive: false });
  document.addEventListener('click', sizeGuideEvent, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSizeGuide(); }, true);
  document.addEventListener('click', function(e){
    var modal = q('#aw-size-guide-modal.open');
    if (modal && e.target === modal) closeSizeGuide();
  }, true);

  function init(){
    buildMobileGalleryUI();
    bindStableMobileSwipe();
  }

  ready(function(){ setTimeout(init, 80); });
  window.addEventListener('load', function(){ setTimeout(init, 160); }, { passive: true });
  window.addEventListener('resize', function(){ setTimeout(init, 80); }, { passive: true });
  document.addEventListener('shopify:section:load', function(){ setTimeout(init, 120); });
  document.addEventListener('shopify:section:select', function(){ setTimeout(init, 120); });
})();


/* ═══ ASWEARE V13 — MINIMAL MOBILE GALLERY UI + SIZE GUIDE TRUE RESCUE ═══ */
(function(){
  if (window.awPdpMobileV13Bound) return;
  window.awPdpMobileV13Bound = true;

  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; }
  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function thumbs(){ return qa('.aw-pdp-thumb'); }
  function isPdp(){ return !!document.querySelector('.aw-pdp-wrap #aw-pdp-img'); }
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function currentIndex(){
    var t = thumbs();
    var active = t.findIndex(function(el){ return el.classList.contains('on'); });
    if (active >= 0) return active;
    var img = q('#aw-pdp-img');
    var n = img && img.dataset.galleryIndex ? parseInt(img.dataset.galleryIndex, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function setIndex(i, userInitiated){
    var img = q('#aw-pdp-img');
    var t = thumbs();
    if (!img || t.length < 1) return false;
    var next = ((i % t.length) + t.length) % t.length;
    var src = t[next].dataset.fullSrc || t[next].dataset.src || (q('img', t[next]) && q('img', t[next]).src);
    if (!src) return false;
    img.classList.add('aw-pdp-img-changing');
    window.setTimeout(function(){
      img.src = src;
      img.dataset.fullSrc = src;
      img.dataset.galleryIndex = String(next);
      t.forEach(function(el, idx){ el.classList.toggle('on', idx === next); });
      window.setTimeout(function(){ img.classList.remove('aw-pdp-img-changing'); }, 90);
    }, userInitiated ? 35 : 0);
    return true;
  }

  function next(){ return setIndex(currentIndex() + 1, true); }
  function prev(){ return setIndex(currentIndex() - 1, true); }

  function buildMinimalMobileGalleryUI(){
    var stage = q('.aw-pdp-stage');
    var t = thumbs();
    if (!stage) return;

    var existing = q('.aw-pdp-mobile-gallery-ui', stage);
    if (!isMobile() || !isPdp() || t.length < 2) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var ui = document.createElement('div');
    ui.className = 'aw-pdp-mobile-gallery-ui';
    ui.innerHTML = '<button type="button" class="aw-pdp-mobile-arrow aw-prev" aria-label="Previous product photo">‹</button>' +
                   '<button type="button" class="aw-pdp-mobile-arrow aw-next" aria-label="Next product photo">›</button>';
    stage.appendChild(ui);

    q('.aw-prev', ui).addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); prev(); });
    q('.aw-next', ui).addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); next(); });
  }

  function findClosestFromPoint(e, selector){
    var direct = e.target && e.target.closest ? e.target.closest(selector) : null;
    if (direct) return direct;
    var x = null, y = null;
    if (typeof e.clientX === 'number' && typeof e.clientY === 'number') {
      x = e.clientX; y = e.clientY;
    } else if (e.touches && e.touches[0]) {
      x = e.touches[0].clientX; y = e.touches[0].clientY;
    } else if (e.changedTouches && e.changedTouches[0]) {
      x = e.changedTouches[0].clientX; y = e.changedTouches[0].clientY;
    }
    if (x == null || y == null || !document.elementsFromPoint) return null;
    var stack = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el && el.closest) {
        var found = el.closest(selector);
        if (found) return found;
      }
    }
    return null;
  }

  function ensureModalInBody(){
    var modal = q('#aw-size-guide-modal');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function openSizeGuide(src){
    var modal = ensureModalInBody();
    var img = q('#aw-size-guide-img');
    if (!modal || !img || !src) return false;
    img.src = src;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('aw-size-guide-open');
    return true;
  }

  function closeSizeGuide(){
    var modal = q('#aw-size-guide-modal');
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aw-size-guide-open');
  }

  function sizeGuideRescue(e){
    var closeEl = findClosestFromPoint(e, '[data-aw-size-guide-close], .aw-size-guide-close');
    if (closeEl) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      closeSizeGuide();
      return;
    }

    var modal = q('#aw-size-guide-modal.open');
    if (modal) {
      var panel = findClosestFromPoint(e, '.aw-size-guide-panel');
      if (!panel) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        closeSizeGuide();
        return;
      }
    }

    var openEl = findClosestFromPoint(e, '[data-aw-size-guide-open], .aw-pdp-size-guide');
    if (openEl) {
      var src = openEl.getAttribute('data-size-guide-src') || openEl.getAttribute('href');
      if (src) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openSizeGuide(src);
      }
    }
  }

  ready(function(){
    ensureModalInBody();
    buildMinimalMobileGalleryUI();
  });
  window.addEventListener('load', function(){ ensureModalInBody(); buildMinimalMobileGalleryUI(); }, { passive: true });
  window.addEventListener('resize', function(){ buildMinimalMobileGalleryUI(); }, { passive: true });

  document.addEventListener('pointerdown', sizeGuideRescue, true);
  document.addEventListener('pointerup', sizeGuideRescue, true);
  document.addEventListener('touchstart', sizeGuideRescue, { capture: true, passive: false });
  document.addEventListener('touchend', sizeGuideRescue, { capture: true, passive: false });
  document.addEventListener('click', sizeGuideRescue, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSizeGuide(); }, true);
})();


/* ═══ ASWEARE V19 — MOBILE STABILITY SAFETY LAYER ═══
   Does not rebuild the PDP. It only removes leftover visual controls, keeps
   normal taps alive, and gives the handle a reliable toggle/drag behavior. */
(function(){
  if (window.awPdpV19StableBound) return;
  window.awPdpV19StableBound = true;

  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 900px)').matches; }
  function isPdp(){ return !!document.querySelector('.aw-pdp-wrap #aw-pdp-img'); }
  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function removeMobileGalleryUi(){
    if (!isMobile() || !isPdp()) return;
    qa('.aw-pdp-mobile-gallery-ui').forEach(function(el){ el.remove(); });
  }

  function ensureHandle(){
    if (!isMobile() || !isPdp()) return;
    var card = q('.aw-pdp-card');
    if (!card) return;
    var handle = q('.aw-pdp-sheet-handle', card);
    if (!handle) {
      handle = document.createElement('button');
      handle.type = 'button';
      handle.className = 'aw-pdp-sheet-handle';
      handle.setAttribute('aria-label', 'Toggle product details');
      card.insertBefore(handle, card.firstChild);
    }
    if (handle.dataset.awV19Bound === 'true') return;
    handle.dataset.awV19Bound = 'true';

    function setState(state){
      card.classList.toggle('aw-sheet-collapsed', state === 'collapsed');
      card.classList.toggle('aw-sheet-expanded', state === 'expanded');
      card.dataset.sheetState = state;
    }
    if (!card.dataset.sheetState) setState('default');

    var startY = 0, dragging = false, moved = false;
    function y(e){
      if (e.touches && e.touches[0]) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientY;
      return e.clientY || 0;
    }
    function start(e){
      if (!isMobile()) return;
      dragging = true;
      moved = false;
      startY = y(e);
      e.preventDefault();
      e.stopPropagation();
    }
    function move(e){
      if (!dragging) return;
      var dy = y(e) - startY;
      if (Math.abs(dy) > 8) moved = true;
      e.preventDefault();
      e.stopPropagation();
    }
    function end(e){
      if (!dragging) return;
      dragging = false;
      var dy = y(e) - startY;
      e.preventDefault();
      e.stopPropagation();
      if (!moved) {
        setState(card.classList.contains('aw-sheet-collapsed') ? 'default' : 'collapsed');
        return;
      }
      if (dy > 34) setState('collapsed');
      else if (dy < -34) setState('expanded');
      else setState('default');
    }

    handle.addEventListener('touchstart', start, { passive:false });
    handle.addEventListener('touchmove', move, { passive:false });
    handle.addEventListener('touchend', end, { passive:false });
    handle.addEventListener('mousedown', start, { passive:false });
    document.addEventListener('mousemove', move, { passive:false });
    document.addEventListener('mouseup', end, { passive:false });
    handle.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); }, true);
  }

  function init(){
    removeMobileGalleryUi();
    ensureHandle();
  }

  ready(function(){ setTimeout(init, 80); });
  window.addEventListener('load', function(){ setTimeout(init, 140); }, { passive:true });
  window.addEventListener('resize', function(){ setTimeout(init, 80); }, { passive:true });
  document.addEventListener('shopify:section:load', function(){ setTimeout(init, 80); });
})();
